import React from 'react'
import { CircularProgress, TextField, Typography } from '@mui/material'
import { com } from '@eidu/web'
import DraftFieldValue from '../../domain/entity/DraftFieldValue'
import Field = com.eidu.sharedlib.entity.field.Field

export type EntityFormNumberInputProps = {
  field: Field
  fieldValue: DraftFieldValue | undefined
  updateField: (value: DraftFieldValue) => void
  error: boolean
  loading?: boolean
  disabled?: boolean
  size?: 'small' | 'medium'
}

const EntityFormNumberInput = ({
  field,
  fieldValue,
  updateField,
  error,
  loading = false,
  disabled = false,
  size,
}: EntityFormNumberInputProps) => (
  <>
    <TextField
      key={`field-${field.id.toString()}`}
      required={field.required}
      label={field.name}
      value={fieldValue?.value ?? ''}
      onChange={(event) => updateField({ fieldId: field.id, type: field.type, value: event.target.value })}
      error={error}
      disabled={disabled || loading}
      placeholder={loading ? ' ' : undefined}
      size={size}
      InputLabelProps={loading ? { shrink: true } : undefined}
      InputProps={{
        endAdornment: loading ? <CircularProgress size={20} /> : undefined,
      }}
    />
    {fieldValue?.value && Number.isNaN(parseFloat(fieldValue.value)) && (
      <Typography>Please enter a valid number</Typography>
    )}
  </>
)

export default EntityFormNumberInput
